import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const EmailVerificationWall = () => {
  const { user, logout } = useAuth();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  const handleResend = async () => {
    if (sent && cooldown > 0) return;
    setSending(true);
    try {
      await api.post("/auth/resend-verification");
      setSent(true);
      toast.success("Verification email sent — check your inbox.");

      // 60 second cooldown to prevent spam clicking
      setCooldown(60);
      const interval = setInterval(() => {
        setCooldown((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

    } catch (err) {
      toast.error("Could not send email. Please try again.");
    } finally {
      setSending(false);
    }
  };

  const buttonDisabled = sending || cooldown > 0;
  const buttonLabel = sending
    ? "Sending..."
    : cooldown > 0
    ? `Resend again in ${cooldown}s`
    : sent
    ? "Resend verification email"
    : "Resend verification email";

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6"
      style={{ backgroundColor: "var(--secondary)" }}
    >
      <div
        className="bg-white rounded-xl border p-10 w-full max-w-md text-center"
        style={{ borderColor: "var(--border)" }}
      >
        <div className="text-4xl mb-4">✉</div>
        <h1 className="text-2xl font-bold mb-2" style={{ fontFamily: "Fraunces, serif" }}>
          Verify your email
        </h1>
        <p className="opacity-70 leading-7 mb-2">
          We sent a verification link to
        </p>
        <p className="font-medium mb-4">{user?.email}</p>
        <p className="opacity-70 leading-7 mb-8 text-sm">
          Click the link in that email to activate your account.
          Check your spam folder if you don't see it.
        </p>

        {sent && cooldown === 0 && (
          <div
            className="w-full py-2 rounded-lg mb-4 text-sm opacity-70"
            style={{ backgroundColor: "var(--secondary)" }}
          >
            Email sent — didn't receive it?
          </div>
        )}

        <button
          onClick={handleResend}
          disabled={buttonDisabled}
          className="btn-primary w-full py-3 rounded-lg disabled:opacity-50 mb-4"
        >
          {buttonLabel}
        </button>

        <button
          onClick={logout}
          className="text-sm opacity-60 hover:opacity-100 underline"
        >
          Sign out and use a different email
        </button>
      </div>
    </div>
  );
};

export default EmailVerificationWall;